export const appConfig = {
  SESSION_USER_NAME: "userName",
  SESSION_USER_EMAIL: "userEmail",
  SESSION_USER_ROLE: "userRole",
  SESSION_USER_TOKEN: "token",
  SESSION_USER_PROFILE_IMAGE: "profileImage",
  SESSION_USER_INFO: "userInfo",
  SESSION_IS_USER_LOGGED_IN: "isUserLoggedIn",
  SESSION_USER_ID: "userId",
  SESSION_USER_PERMISSIONS: "permissions",
};
